import { ReactNode } from 'react'

import PanelRadioGroup from './PanelRadioGroup'
import styles from './PanelOptionTiles.module.scss'

type PanelTile = {
  id: string
  icon?: ReactNode
  label: ReactNode
  hint?: ReactNode
  disabled?: boolean
  testId?: string
}

type PanelOptionTilesProps = {
  tiles: PanelTile[]
  selectedId: string | null | undefined
  onSelect: (id: string) => void
  ariaLabel: string
}

/** Two-up choice tiles, e.g. pickup or delivery */
export default function PanelOptionTiles({
  tiles,
  selectedId,
  onSelect,
  ariaLabel,
}: PanelOptionTilesProps) {
  return (
    <PanelRadioGroup
      items={tiles}
      selectedId={selectedId}
      onSelect={onSelect}
      ariaLabel={ariaLabel}
      className={styles.tiles}
      itemClassName={styles.tile}
      selectedClassName={styles.selected}
      renderItem={tile => (
        <>
          {tile.icon && (
            <span className={styles.icon} aria-hidden>
              {tile.icon}
            </span>
          )}
          <span className={styles.text}>
            <span>{tile.label}</span>
            {tile.hint && <span className={styles.hint}>{tile.hint}</span>}
          </span>
        </>
      )}
    />
  )
}
